document.addEventListener('DOMContentLoaded', function() {
    var openCookies = document.querySelector('a[href="#open-cookies"]');
    if (openCookies) { // Check if the element exists
        openCookies.addEventListener('click', function(e) {
            var target = e.target || e.srcElement;
            if(target.tagName.toLowerCase() === 'a' && target.getAttribute('href') === '#open-cookies') {
                e.preventDefault(); // Prevent the default action (navigation) of the link
                Optanon.ToggleInfoDisplay();
            }
        });
    }
});

if (window.performance) {
     var navEntries = window.performance.getEntriesByType('navigation');
     if (navEntries.length > 0 && navEntries[0].type === 'back_forward') {
            get_cartitems();
     } else if (window.performance.navigation
          && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
            get_cartitems();
     } 
}
$(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
      get_cartitems();
    }
});
function get_cartitems() {
  setTimeout(function(){
		$.getJSON('/cart.js', function(cart){ 
			var result_ic = cart.item_count;
            $('.Header__CartCount').html(result_ic);
		});
	},50);
}

/* WeDev */

/* ========== GLOBAL FUNCTIONS ========== */
/* Cart drawer */
const openCartDrawer = () => {
  $(".size-modal-backdrop").removeClass('is-active')
  $("body > .backdrop, .wd-cart-drawer").addClass('is-active');
}
const closeCartDrawer = () => {
  $("body > .backdrop, .size-modal-backdrop, .wd-cart-drawer").removeClass('is-active');
}
const getCart = async () => {
  return await $.get(`${window.Shopify.routes.root}cart.js`, null, (cart) => cart, 'json')
}
const updateCartCount = async (itemCount = null) => {
  if(itemCount) {
    $('.Header__CartCount').html(itemCount);
    return;
  }
  const { item_count } = await getCart();
  $('.Header__CartCount').html(item_count)
}
const rebuildCartDrawer = async () => {
  const url = `${window.location.origin}?section_id=wd-cart-drawer`;
  $('.wd-cart-drawer').addClass('order-note-active');
  try {
    const { item_count } = await getCart();
    const cartDrawerHTML = await $.get(url, null, (data) => data, 'html').fail((err) => {throw err});
    if(cartDrawerHTML.length) {
      const shippingProgressBar = $(cartDrawerHTML).find('shipping_bar__wrapper');
      const cartContent = $(cartDrawerHTML).find('form[action="/cart"]');
      $('.wd-cart-drawer .shipping_bar__wrapper').replaceWith(shippingProgressBar);
      $('.wd-cart-drawer form[action="/cart"]').replaceWith(cartContent);
      updateCartCount(item_count);
      updateCartDrawerEvents();
      $('.wd-cart-drawer').removeClass('order-note-active');
      if(item_count > 0) {
        $('.wd-cart-drawer').removeClass('cart_empty');
      }
      return;
    }
    throw 'Failed to receive "wd-cart-drawer" section HTML';
  } catch (err) {
    console.log(err);
    debugger;
    window.location.reload();
  }
}
const rebuildCartHeader = () => {
  const section_id = $('.cart-header-wrap').data('section-id');
  const url = `${window.location.origin}/cart?section_id=${section_id}`;
  $.get(url, null, (data) => {
    const newCartHeader = $(data).find(`.cart-header-wrap[data-section-id=${section_id}]`);
    $(`.cart-header-wrap[data-section-id=${section_id}]`).replaceWith(newCartHeader);
  }, 'html');
}
const cartItemChangeHandler = (e, qtyDif) => {
  e.preventDefault();
  const $qtyInput = $(e.currentTarget).parent().children('input.qty-input');
  const body = {
    id: $(e.currentTarget).data('line-id'),
    quantity: qtyDif ? Number($qtyInput.val()) + qtyDif : 0
  }
  if ($(e.currentTarget).hasClass('qty-input')) {
    body.quantity = e.currentTarget.value;
  }
  $.post(`${window.Shopify.routes.root}cart/change.js`, body, ({total_price}) => {
    const totalPrice = (total_price / 100).toFixed(2);
    $qtyInput.val(body.quantity);
    $('.wd-cart-drawer .checkout-btn > .total-price').html(`$${totalPrice}`);
    if(body.quantity == 0) {
      $(`.wd-cart-drawer .cart_item[data-line-id="${body.id}"]`).animate({height: 0, opacity: 0, margin: 0, ease: 'easeInOut'});
    }
    if (totalPrice == 0) {
      $('.wd-cart-drawer').addClass('cart_empty');
      setTimeout(() => {
        $('.wd-cart-drawer .drawer-content').html('<li class="cart_empty"><h4>YOUR CART IS EMPTY</h4></li>');
        $('.wd-cart-drawer .drawer-footer').remove();
      }, 500);
      rebuildCartDrawer();
      return;
    }
    $('.wd-cart-drawer').removeClass('cart_empty');
    rebuildCartDrawer();
  }, 'json');
}
const toggleOrderNoteHandler = () => {
  const ariaHidden = $('.wd-cart-drawer .Cart__OffscreenNoteContainer').attr("aria-hidden");
  $('.wd-cart-drawer').toggleClass('order-note-active');
  $('.wd-cart-drawer .Cart__OffscreenNoteContainer')
  .attr("aria-hidden", ariaHidden === 'false' ? true : false);
}

const updateCartDrawerEvents = () => {
  $(".add_to_cart").off('click');
  $('.wd-cart-drawer > .drawer-header > svg.icon-close').off('click')
  $('.wd-cart-drawer .cart_item--minus').off('click');
  $('.wd-cart-drawer .cart_item--plus').off('click');
  $('.wd-cart-drawer .cart_item--remove').off('click');
  $('.wd-cart-drawer .qty-input').off('change');
  $('.wd-cart-drawer .order-note-trigger, .wd-cart-drawer [data-action="toggle-cart-note"]').off('click');
  $(".add_to_cart").click(async (e) => {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const $loadingSpinner = $btn.children('.loading-overlay__spinner');
    const $checkIcon = $btn.children('.check-icon');
    if($btn.hasClass('add_to_cart')) {
      $btn.attr('disabled', true);
      $loadingSpinner.removeClass('hidden');
      if($btn.parents('section.main-product-section').length) {
        $btn.children('span').text('ADDED');
      }
    }
    const body = {
      items: [
        {
          id: $btn.attr("data-variant-id"),
          quantity: 1
        }
      ]
    };
    await $.post(`${window.Shopify.routes.root}cart/add.js`, body, async () => {
      if($btn.hasClass('add_to_cart')) {
        $btn.attr("disabled", false);
        $loadingSpinner.addClass("hidden");
        $checkIcon.removeClass("hidden");
      }
      await $.get(`${window.Shopify.routes.root}cart.js`, null, async (cart) => {
        if($btn.hasClass('add_to_cart')) {
          $checkIcon.addClass("hidden");
          $btn
          .parents(".wd-product-card .card__content.is-open")
          .removeClass("is-open mobile-view");
          $btn
          .parents(".quick-add-modal")
          .find("input")
          .each((i, el) => $(el).prop("checked", false));
        }
        $("header .cm-header-icon-cart .Header__CartCount").html(cart.item_count);
      }, "json");
    },"json").fail(({ responseJSON: response }) => {
      console.error(response);
      if($btn.hasClass('add_to_cart')) {
        $btn.attr("disabled", true);
        $btn
        .parents(".wd-product-card .card__content.is-open")
        .removeClass("is-open mobile-view");
        $loadingSpinner.addClass("hidden");
        $checkIcon.addClass("hidden");
        $btn
        .parents(".quick-add-modal")
        .find("input")
        .each((i, el) => {
          $(el).prop("checked", false);
        });
      }
    });
    if(window.location.pathname.includes('cart')) {
      const section_id = $('table.cart-items').data('section-id');
      const url = `${window.location.origin}?section_id=${section_id}`;
      $.get(url, null, (data) => {
        const newCartTable = $(data).find(`table.cart-items[data-section-id=${section_id}]`);
        $('table.cart-items').replaceWith(newCartTable);
        window.scrollTo({top: 0, behavior: 'smooth'});
      }, 'html');
      await rebuildCartDrawer();
      if($btn.parents('section.main-product-section').length) {
        $btn.children('span').text('ADD TO BAG');
      }
      return;
    }
    await rebuildCartDrawer();
    openCartDrawer();
    if($btn.parents('section.main-product-section').length) {
      $btn.children('span').text('ADD TO BAG');
    }
});
  $('.wd-cart-drawer > .drawer-header > svg.icon-close').click(closeCartDrawer);
  $('.wd-cart-drawer .cart_item--minus').click((e) => cartItemChangeHandler(e, -1));
  $('.wd-cart-drawer .cart_item--plus').click((e) => cartItemChangeHandler(e, 1));
  $('.wd-cart-drawer .cart_item--remove').click((e) => cartItemChangeHandler(e, 0))
  $('.wd-cart-drawer .qty-input').change((e) => cartItemChangeHandler(e, 0))
  $('.wd-cart-drawer .order-note-trigger, .wd-cart-drawer [data-action="toggle-cart-note"]').click(toggleOrderNoteHandler);
}

const quickAddEventsInit = () => {
  // Close modal
  $(".size-modal-backdrop, .wd-product-card .card__content .quick-add-modal > .close").click(function () {
    $(this).removeClass("is-active");
    if($(this).hasClass('close')) {
      $(this).parents('.wd-product-card .card__content.is-open').removeClass("is-open");
      $(this).parent().prev('.size-modal-backdrop').removeClass("is-active");
    }
    $(".wd-product-card .card__content.is-open").removeClass("is-open");

  });

  // Open modal
  $("button.quick-add-btn:not(.is-accessory) > .quick-add-desktop").click(function () {
    $(this).parent().parent().addClass("is-open");
  });
  $("button.quick-add-btn:not(.is-accessory) > .quick-add-mobile").click(function () {
    $(this).parent().siblings(".size-modal-backdrop").addClass("is-active");
    $(this).parent().parent().addClass("is-open");
  });

  // Modal size selection state
  $(".wd-product-card .card__content .quick-add-modal > ul > li > input").change(function () {
    if ($(this).is(":checked")) {
      $(this)
        .parents(".quick-add-modal")
        .find(".add_to_cart")
        .attr({
          "data-variant-id": $(this).attr("data-variant-id"),
          "data-preorder": $(this).attr("data-is-preorder"),
          disabled: false
        });
    }
  });

  $(".add_to_cart, .quick-add-btn.is-accessory").click(async (e) => {
      e.preventDefault();
      const $btn = $(e.currentTarget);
      // [plus] checks if the product has a recipient form and if it's checked
      const hasRecipient = $(document)
        .find('[name="properties[__shopify_send_gift_card_to_recipient]"]')
        ?.is(":checked");
      const $loadingSpinner = $btn.children('.loading-overlay__spinner');
      const $checkIcon = $btn.children('.check-icon');
      if($btn.hasClass('add_to_cart')) {
        $btn.attr('disabled', true);
        $loadingSpinner.removeClass('hidden');
        if($btn.parents('section.main-product-section').length) {
          $btn.children('span').text('ADDED');
        }
      }
      // [plus] if the product has a recipient form, we get the values from the form
      const properties = {};
      if (hasRecipient) {
        document
          .querySelectorAll(`[name*="properties"]:not([disabled])`)
          .forEach((c) => {
            const $el = $(c);

            properties[$el.attr("name")] = $el.val();
          });
      }
      // [plus] we add the properties to the body
      const body = {
          items: [
            {
              id: $btn.attr("data-variant-id"),
              quantity: 1,
              ...properties
            }
          ],
        }
      await $.post(`${window.Shopify.routes.root}cart/add.js`, body, async () => {
        if($btn.hasClass('add_to_cart')) {
          $btn.attr("disabled", false);
          $loadingSpinner.addClass("hidden");
          $checkIcon.removeClass("hidden");
        }
        const $emailErrorElement = $('[id*="RecipientForm-email-error"]');
        if ($emailErrorElement.length) {
          $emailErrorElement.addClass('hidden');
          $emailErrorElement.children('.error-message').text('');
        }
        await $.get(`${window.Shopify.routes.root}cart.js`, null, async (cart) => {
          if($btn.hasClass('add_to_cart')) {
            $checkIcon.addClass("hidden");
            $btn
            .parents(".wd-product-card .card__content.is-open")
            .removeClass("is-open mobile-view");
            $btn
            .parents(".quick-add-modal")
            .find("input")
            .each((i, el) => $(el).prop("checked", false));
          }
          $("header .cm-header-icon-cart .Header__CartCount").html(cart.item_count);
        }, "json");
      },"json").fail(({ responseJSON: response }) => {
        console.error(response);
        if(response.description.email) {
          const emailError = response.description.email[0];
          const $emailErrorElement = $('[id*="RecipientForm-email-error"]');
          $emailErrorElement.removeClass('hidden');
          $emailErrorElement.children('.error-message').text(emailError);
          $btn.children("span").text("ADD TO BAG");
          $btn.attr("disabled", false);
          $loadingSpinner.addClass("hidden");
        } else {
          if($btn.hasClass('add_to_cart')) {
            $btn.attr("disabled", true);
            $btn
            .parents(".wd-product-card .card__content.is-open")
            .removeClass("is-open mobile-view");
            $loadingSpinner.addClass("hidden");
            $checkIcon.addClass("hidden");
            $btn
            .parents(".quick-add-modal")
            .find("input")
            .each((i, el) => {
              $(el).prop("checked", false);
            });
          }
        }
      });
      if(window.location.pathname.includes('cart')) {
        const section_id = $('table.cart-items').data('section-id');
        const url = `${window.location.origin}?section_id=${section_id}`;
        $.get(url, null, (data) => {
          const newCartTable = $(data).find(`table.cart-items[data-section-id=${section_id}]`);
          $('table.cart-items').replaceWith(newCartTable);
          window.scrollTo({top: 0, behavior: 'smooth'});
        }, 'html');
        await rebuildCartDrawer();
        if($btn.parents('section.main-product-section').length) {
          $btn.children('span').text('ADD TO BAG');
        }
        return;
      }
      await rebuildCartDrawer();
      openCartDrawer();
      if($btn.parents('section.main-product-section').length) {
        $btn.children('span').text('ADD TO BAG');
      }
  });
}

$(() => {
  /* ========== wd-flickity-slider (Product page - mobile) ========== */
  $('.wd-flickity-slider > .flickity-page-dots').append(function(){
    return $(this).parents('.wd-flickity-slider').children('.flickity-button.next');
  })
  $('.wd-flickity-slider > .flickity-page-dots').prepend(function(){
    return $(this).parents('.wd-flickity-slider').children('.flickity-button.previous');
  })
  $('.wd-flickity-slider').css('opacity', 1);

  // Close all drawers on backdrop click
  $('.backdrop').click(() => {
    $('.wd-drawer').each((i, drawer) => {
      $(drawer).removeClass('is-active')
    })
  })

  /* ========== Cart drawer ========== */
  $('body > .backdrop, .size-modal-backdrop, .wd-cart-drawer > .drawer-header > svg.icon-close').click(closeCartDrawer);
  $('.wd-cart-drawer .cart_item--minus').click((e) => cartItemChangeHandler(e, -1));
  $('.wd-cart-drawer .cart_item--plus').click((e) => cartItemChangeHandler(e, 1));
  $('.wd-cart-drawer .cart_item--remove').click((e) => cartItemChangeHandler(e, 0))
  $('.wd-cart-drawer .qty-input').change((e) => cartItemChangeHandler(e, 0))
  $('.wd-cart-drawer .order-note-trigger, .wd-cart-drawer [data-action="toggle-cart-note"]').click(toggleOrderNoteHandler);

  /* ========== Quick add modal (product grid) ========== */
    quickAddEventsInit();

  /* Change pagination href */
  const changePaginationHref = (newUrl) =>{
    if (window.collectionPaging) {
      const currentPageNum = newUrl.match(/page\=(?<page>[0-9]*)/)?.groups?.page;
      
      $(".pagination__item.link.navigable").each((index,e)=> {
        let paginationNum =  $(e).attr("href").match(/page\=(?<page>[0-9]*)/)?.groups?.page;
      
        if(paginationNum!==currentPageNum){
          let regex = (/page\=(?<page>[0-9]*)/);
          let paginationNewHref = newUrl.replace( regex, 'page=' + paginationNum )

          return $(e).attr("href", paginationNewHref );
        };
      });
    } else {
      let next_url = $('.products-on-page').data('next-url');
      let next_url_number = next_url.match(/page\=(?<page>[0-9]*)/)?.groups?.page;
      let previous_url = $('.products-on-page').data('previous-url');
      let previous_url_number = previous_url.match(/page\=(?<page>[0-9]*)/)?.groups?.page;
      let newUrl_page_num = newUrl.match(/page\=(?<page>[0-9]*)/)?.groups?.page;
      let new_next_url = newUrl.replace(newUrl_page_num, next_url_number);
      let new_previous_url = newUrl.replace(newUrl_page_num, previous_url_number);
      $('.products-on-page').attr("data-next-url", new_next_url);
      $('.products-on-page').attr("data-previous-url", new_previous_url);
    }
  };

  
  /* Sort */
  $('.filterSortButtons > .sortButton > ul > li').click(function () {
    if(window.location.href.includes($(this).data('sort')) || $(this).hasClass('is-selected')) return;
    $(this).parent().children('li').each((i, el) => $(el).removeClass('is-selected'));
    $(this).addClass('is-selected');

    if (window.collectionPaging) {
      const products_section_id = $(".wd-filter-drawer button.filter-apply").data("section-id");
      const page_query = window.location.href.match(/page\=(?<page>[0-9]*)/)?.groups?.page || 1;
      const url = `${window.location.href.split('?')[0]}?page=${page_query}&sort_by=${$(this).data('sort')}`;

      changePaginationHref(url)
      
      $.get(url, null, (data) => {
        const filtered_product_grid = $(data).find(`#product-grid[data-id="${products_section_id}"]`);
        $(`#shopify-section-${products_section_id} #product-grid[data-id="${products_section_id}"]`).replaceWith(filtered_product_grid);
        if (history.replaceState) {
          window.history.pushState({ path: url }, '', url);

        /* ========== Quick add modal (product grid) ========== */
          quickAddEventsInit();

        }
      }, 'html');
    } else {
      const page_query = window.location.href.match(/page\=(?<page>[0-9]*)/)?.groups?.page || 1;
      const url = `${window.location.href.split('?')[0]}?page=1&sort_by=${$(this).data('sort')}`;
  
      changePaginationHref(url)
    
      $.get(`${url}&section_id=collection-products`, null, (data) => {
        window.handleCollectionResponse(data, "next-url", true);
  
        if (history.replaceState) {
          window.history.replaceState({ path: url }, '', url);
  
         /* ========== Quick add modal (product grid) ========== */
          quickAddEventsInit();
  
        }
      }, 'html');
    }
  })
  
  /* ========== Filter drawer ========== */
  // Open/close drawer
  $('.filterSortButtons .filterButton').click(() => {
    $("body > .backdrop, .wd-filter-drawer").addClass('is-active')
  })
  $('.wd-filter-drawer > .drawer-header > svg').click(() => {
    $("body > .backdrop, .wd-filter-drawer").removeClass('is-active')
  })
  $('.wd-filter-drawer > ul.drawer-content > li.filter-type.mobile-tab').click(function () {
    $(this).next('ul.filters-list').slideToggle();
    $(this).toggleClass('is-active');
  })
  // Filter values selection state
  $('.wd-filter-drawer ul.filters-list > li').click(function () {
    if($(this).hasClass('is-selected')) {
      $(this).removeClass("is-selected");
      return;
    }
    $(this)
    .parents("ul.filters-list")
    .children("li")
    .each((i, el) => {
      $(el).removeClass("is-selected");
    });
    $(this).addClass("is-selected");
  })

  // Apply filters
  $(".wd-filter-drawer button.filter-apply").click(function () {
    let amountOfFilters = 0;
    const chosenFilters = $('.wd-filter-drawer ul.filters-list > li.is-selected')
    .map((i, el) => {
        amountOfFilters++;
        const filterGroup = $(el).data("filter-group").toLowerCase().replace(' ', '-');
        const filterValue = $(el).children('label').text().toLowerCase().replace(' ', '-');
        return `${filterGroup}_${filterValue}`
      })
      .get()
      .join("+");
    document.querySelector("button.filterButton").innerHTML = "Filter" + (amountOfFilters ? ` (${amountOfFilters})` : "")
    if (!chosenFilters) return;
    const products_section_id = $(this).data("section-id");
    const url_path = $(this).data('url');
    const sort_by_query = window.location.href.split('sort_by=')[1]?.split('&')[0] || 'manual';
    const page_query = window.location.href.match(/page\=(?<page>[0-9]*)/)?.groups?.page || 1;
    if (window.collectionPaging) {
      const url = `${url_path}/${chosenFilters}?section_id=${products_section_id}&sort_by=${sort_by_query}`
      changePaginationHref(`${url_path}/${chosenFilters}?page=${page_query}&sort_by=${sort_by_query}`)

      $.get(url, null, (data) => {
        const filtered_product_grid = $(data).find(`#product-grid[data-id="${products_section_id}"]`);
        $(`#shopify-section-${products_section_id} #product-grid[data-id="${products_section_id}"]`).replaceWith(filtered_product_grid);
        if (history.replaceState) {
          const newUrl = `${url_path}/${chosenFilters}?page=${page_query}&sort_by=${sort_by_query}`;
          window.history.pushState({ path: newUrl }, '', newUrl);

        /* ========== Quick add modal (product grid) ========== */
          quickAddEventsInit();

        }
        $(".wd-filter-drawer button.filter-reset").removeClass('hidden');
        location.reload();
      }, 'html');
    } else {
      const url = `${url_path}/${chosenFilters}?section_id=collection-products&sort_by=${sort_by_query}`
      changePaginationHref(`${url_path}/${chosenFilters}?page=1&sort_by=${sort_by_query}`)
  
      $.get(url, null, (data) => {
        window.handleCollectionResponse(data, "next-url", true);
  
        if (history.replaceState) {
          const newUrl = `${url_path}/${chosenFilters}?page=1&sort_by=${sort_by_query}`;
          window.history.replaceState({ path: newUrl }, '', newUrl);
  
        /* ========== Quick add modal (product grid) ========== */
          quickAddEventsInit();
  
        }
        $(".wd-filter-drawer button.filter-reset").removeClass('hidden');
      }, 'html');
    }
  });

  // Reset filters
  $(".wd-filter-drawer button.filter-reset").click(function () {
    $('.wd-filter-drawer ul.filters-list > li.is-selected').each((i, el) => $(el).removeClass('is-selected'))
    $(".wd-filter-drawer button.filter-reset").addClass('hidden');
    const products_section_id = $(this).data("section-id");
    const url_path = $(this).data('url');
    const sort_by_query = window.location.href.split('sort_by=')[1]?.split('&')[0] || 'manual';
    if (window.collectionPaging) {
      const url = `${url_path}?section_id=${products_section_id}&sort_by=${sort_by_query}`
      $.get(url, null, (data) => {
        const product_grid = $(data).find(`#product-grid[data-id="${products_section_id}"]`);
        $(`#shopify-section-${products_section_id} #product-grid[data-id="${products_section_id}"]`).replaceWith(product_grid);
        $('button.filterButton').html("Filter");
        if (history.replaceState) {
          const newUrl = `${url_path}?sort_by=${sort_by_query}`;
          window.history.pushState({ path: newUrl }, '', newUrl);
          /* ========== Quick add modal (product grid) ========== */
          quickAddEventsInit();
              location.reload();
        }
      }, 'html');
    } else {
      const url = `${url_path}?section_id=collection-products&sort_by=${sort_by_query}`
      $.get(url, null, (data) => {
        window.handleCollectionResponse(data, "next-url", true);
  
        $('button.filterButton').html("Filter");
        if (history.replaceState) {
          const newUrl = `${url_path}?sort_by=${sort_by_query}`;
          window.history.replaceState({ path: newUrl }, '', newUrl);
           /* ========== Quick add modal (product grid) ========== */
           quickAddEventsInit();
        }
      }, 'html');
    }

  });
})

  /* START:: SIZE CHART */
  $(document).on('click', '.sizeChartBtn', function(e){
    e.preventDefault();
    var $el = $(this);
    var target = $el.attr('target');
    console.log()
    $(target).show().addClass('popup-active');
  });

  $(document).on('click', '.closeSizeChart', function(e){
    e.preventDefault();
    var $el = $(this);
    var target = $el.attr('target');
    $(target).hide().removeClass('popup-active');
  });

  $(document).on('click', '.tabLink', function(e){
    e.preventDefault();
    var $el = $(this);
    $('.tabLink').removeClass('active');
    $el.addClass('active');
    var target = $el.attr('target');
    $('.tabContent').hide();
    $(target).show();
  });

  $('.tabLink').first().trigger('click');

  $(window).on('click', function(e){
    if(e.target.id === 'sizeChartPopup') {
      var target = $('#sizeChartPopup');
      $(target).hide().removeClass('popup-active');
    }
  });
  /* END:: SIZE CHART */


  
  /* Detect if mobile */
  window.isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
